<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img src="../../assets/image/RUS.png" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">

                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" v-if="$route.meta.prev"  @click="$router.push($route.meta.prev)">
                    上一步
                </span>
                <span class="btn" v-if="$route.meta.next" @click="$router.push($route.meta.next)">
                    下一步
                </span>
            </div>
        </div>
    </scroll-wrap>
</template>

<script>
    import * as THREE from 'three'
    export default {
        name: "investigate",
        data() {
            return {
                list: [
                    'ASpace.png',
                    'BSpace.png'
                ],
                count:'',
                camera: null,
                scene: null,
                renderer: null,
                mesh: null
            }
        },
        mounted() {
            this.init()
            this.animate()
        },
        methods:{
            init: function () {
                let container = document.getElementsByClassName('main-area-box')[0]
                this.camera = new THREE.PerspectiveCamera(70, container.clientWidth / container.clientHeight, 0.01, 10)
                this.camera.position.z = 0.6
                this.scene = new THREE.Scene()
                let geometry = new THREE.BoxGeometry(0.2, 0.2, 0.2)
                let material = new THREE.MeshNormalMaterial()
                this.mesh = new THREE.Mesh(geometry, material)
                this.scene.add(this.mesh)

                this.renderer = new THREE.WebGLRenderer({antialias: true})
                this.renderer.setSize(container.clientWidth, container.clientHeight)
                container.appendChild(this.renderer.domElement)
            },
            animate: function () {
                requestAnimationFrame(this.animate)
                this.mesh.rotation.x += 0.01
                this.mesh.rotation.y += 0.02
                this.renderer.render(this.scene, this.camera)
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;min-width:364px;
                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                .main-area-box {
                    width: 1038px;
                    height: 500px;
                    display: flex;
                    .left-wrap {

                    }
                    .line {
                        height: 100%;
                        border-left: 1px dashed #000;
                        margin: 0 48px;
                    }
                    .rigth-wrap {

                    }
                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
